<template>
	<div>
		<!-- <changeLang /> -->
		<div id="login" v-if="!isLoading">
			<md-card class="md-elevation-5 card" v-bind:class="{ shakingcard: error }">
				<md-card-header class="flex" data-background-color="purple">
					<h3 class="center">
						{{
							$t(
								$route.params.conf_code
									? `confirm-registration-${$route.params.purpose}`
									: "login-header"
							)
						}}
					</h3>
				</md-card-header>

				<md-card-content
					class="card-content"
					style="margin-top: 20px"
					v-if="$route.params.purpose === 'school'"
				>
					<div class="center" style="width: 80%">
						<div class="center-content">
							<md-icon class="md-size-3x" style="color: #c9c9c9">
								{{ org_conf ? "check_circle" : "error" }}
							</md-icon>
							<p
								v-html="org_conf ? $t('school-confirmation-success') : $t('school-confirmation-error')"
							/>
						</div>
					</div>
				</md-card-content>
				<md-card-content class="card-content" v-else>
					<div class="center" style="width: 80%" v-if="!showConfirmRegistrationSuccess">
						<div>
							<md-field>
								<md-icon v-bind:style="{ color: error ? 'red' : 'grey' }"> account_circle </md-icon>
								<md-input
									v-model="usernameoremail"
									:placeholder="$t('usernameoremail')"
									required
									@input="error = false"
								/>
							</md-field>
							<md-field>
								<md-icon v-bind:style="{ color: error ? 'red' : 'grey' }">vpn_key</md-icon>
								<md-input
									name="password"
									v-model="password"
									:placeholder="$t('password')"
									type="password"
									@keyup.enter.native="login"
									@input="error = false"
								/>
							</md-field>
						</div>

						<div v-if="!$route.params.conf_code" class="center-content with-padding-top">
							<md-button
								class="md-round md-primary center"
								style="padding: 10px"
								@click="login"
								:disabled="!isValid"
							>
								{{ $t("login") }}
							</md-button>
							<p>{{ $t("or") }}</p>
							<md-button
								class="md-round md-primary center"
								style="padding: 10px"
								@click="goto('/signup')"
							>
								{{ $t("register-instead") }}
							</md-button>
						</div>

						<div v-if="$route.params.conf_code" class="center-content with-padding-top">
							<md-button
								class="md-round md-primary center"
								style="padding: 10px"
								@click="login"
								:disabled="!isValid"
							>
								{{ $t("login") }}
							</md-button>
						</div>

						<div v-if="!$route.params.conf_code" class="flex with-padding-top">
							<router-link class="center" to="resetpassword">
								{{ $t("password-forgotten") }}
							</router-link>
						</div>
					</div>
					<div class="center" style="width: 80%" v-else>
						{{ $t("waiting-school-email-confirmation") }}
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import ChangeLang from "./layout/layout-components/ChangeLang"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { goto } from "@/utils/utils"

export default {
	name: "Login",
	data() {
		return {
			usernameoremail: undefined,
			password: undefined,
			error: false,
			org_conf: undefined,
			showConfirmRegistrationSuccess: false
		}
	},
	computed: {
		...mapGetters({
			logged: "user/logged",
			user: "user/user",
			loginErr: "user/loginErr",
			isLoading: "modules/loading"
		}),
		isValid: function () {
			return this.usernameoremail && this.password
		}
	},
	async created() {
		await this.doReset()

		if (this.$route.params.purpose === "school")
			axios
				.post(process.env.VUE_APP_API_URL + "/api/organizations/confirm", {
					confirmation_code: this.$route.params.conf_code
				})
				.then(() => (this.org_conf = true))
				.catch(err => {
					this.org_conf = false
					console.error(err)
					this.$processError(this.$t("school-confirmation-error"), err.response.data.Message)
				})
	},
	watch: {
		loginErr: function (val) {
			if (val) {
				this.error = true
				switch (val) {
					case 1:
						this.$processError(this.$t("confirmation-code-error"), ["err"])
						break
					case 2:
						this.$processError(this.$t("login-error"), ["err"])
						break
					case 4:
						this.$processError(this.$t("expired-password-title"), ["expired-password"])
						break
				}
			}
		}
	},
	methods: {
		...mapActions({
			doLogin: "user/doLogin",
			doReset: "user/doReset"
		}),
		...mapMutations({
			openload: "modules/OPEN_LOADING",
			closeload: "modules/CLOSE_LOADING"
		}),
		goto,
		async login() {
			this.doLogin({
				usernameoremail: this.usernameoremail,
				password: this.password,
				confirmationcode: this.$route.params.conf_code,
				purpose: this.$route.params.purpose
			})
				.then(return_err => {
					if (!return_err) {
						if (this.$route.params.purpose) this.showConfirmRegistrationSuccess = true

						setTimeout(() => {
							this.closeload()
						}, 1000)
					}
				})
				.catch(err => {
					console.error(err)
				})
		}
	},
	components: {
		changeLang: ChangeLang
	}
}
</script>

<style scoped lang="scss">
@import "../assets/scss/custom-buttom";
#login {
	margin: 0;
	position: absolute !important;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
}
.center {
	margin: auto;
}
.card {
	min-width: 400px;
}
.card-content {
	display: flex;
	margin-top: 50px;
}
.center-content {
	text-align: center;
}
.flex {
	display: flex;
}
.with-margin-top {
	margin-top: 20px;
}
.with-padding-top {
	padding-top: 20px;
}

.shakingcard {
	animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	transform: translate3d(0, 0, 0);
	backface-visibility: hidden;
	perspective: 1000px;
}
@keyframes shake {
	10%,
	90% {
		transform: translate3d(-1px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(2px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-4px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(4px, 0, 0);
	}
}
</style>
